import request from 'utils/request';

const PREFIX = '/api/adv/hedge/app/';

export const AdvHedgeAppAPI = {
  LIST: PREFIX + 'list',
  ADD: PREFIX + 'add',
  AUDIT: PREFIX + 'audit',
  PREVIEW: PREFIX + 'preview',
  AUTO_PAT: PREFIX + 'auto-receipt/',
};

export function getAdvHedgeAppList(data) {
  return request({
    url: AdvHedgeAppAPI.LIST,
    method: 'post',
    data,
  });
}

export function addAdvHedgeApp(data) {
  return request({
    url: AdvHedgeAppAPI.ADD,
    method: 'post',
    data,
  });
}

export function auditAdvHedgeAppStatus(data) {
  return request({
    url: AdvHedgeAppAPI.AUDIT,
    method: 'post',
    data,
  });
}

export function getAdvHedgeAppPreviewData(data) {
  return request({
    url: AdvHedgeAppAPI.PREVIEW,
    method: 'post',
    data,
  });
}

export function advPaymentAutoReceiptProcess(affHedgeAppNumber) {
  return request({
    url: AdvHedgeAppAPI.AUTO_PAT + affHedgeAppNumber,
    method: 'get',
  });
}
